import { useJobDistributionApi } from '@/composables/useApi';
import { InternalError } from '@/core/shared/errors/internal.error';

type IntakeAddressOutput = {
  address: string;
};

export class IntakeAddressPersistence {
  public async getIntakeAddress(jobId: number): Promise<string> {
    const url = `/v1/jobs/${jobId}/intake-address`;
    const { data, error, statusCode } = await useJobDistributionApi(url)
      .get()
      .json<IntakeAddressOutput>();

    if (error.value || !data.value) {
      throw new InternalError('Could not get intake address', {
        error: error.value,
        status: statusCode.value,
        data: { jobId },
      });
    }

    return data.value.address;
  }
}
